<app-loader [hideSpinner]="isDataLoaded"></app-loader>
<div [ngClass]="{ 'hidden': !isDataLoaded }" class="product-view-container" *ngIf="state">
	<nav class="product-header sticky-top navbar navbar-light bg-light" [ngClass]="{ 'im-dirty': isModified }">
		<span class="navbar-brand">State View</span>
		<div class="navbar-nav mr-auto"></div>
		<button type="button" class="btn btn-secondary btn-cancel mr-1" (click)="cancel()">
			<span>Reset Form</span>
		</button>
		<button type="button" class="btn btn-primary btn-save mr-1" (click)="save()">
			<span>Save</span>
		</button>
		<button type="button" class="btn btn-danger btn-delete mr-1" (click)="delete()">
			<span>Delete</span>
		</button>
		<button *ngIf="state.active" type="button" class="btn btn-warning btn-deactivate mr-1" (click)="deactivate()">
			<span>Deactivate</span>
		</button>
		<button *ngIf="!state.active" type="button" class="btn btn-primary btn-activate mr-1" (click)="activate()">
			<span>Activate</span>
		</button>
		<button mat-icon-button class="btn-close" (click)="back()">
			<mat-icon>close</mat-icon>
		</button>
	</nav>
	<div class="product-container">
		<mat-card>
			<div class="row">
				<div class="col-8">
					<label>State Name</label> 
					<div class="input-group mb-3">
						<input [(ngModel)]="state.name" type="text" class="form-control" (input)="dataChanged()">
					</div>
					<label>State Code</label>
					<div class="input-group mb-3">
						<input [(ngModel)]="state.code" type="text" class="form-control" (input)="dataChanged()">
					</div>
					<label>Courier</label>
					<select [(ngModel)]="state.courierId" name="courierId" class="custom-select" required>
						<option value="0">Select a courier</option>
						<option *ngFor="let courier of couriers" value="{{courier.id}}">{{ courier.name }}</option>
					</select>
					<label>Description</label>
					<div class="input-group mb-3">
						<textarea [(ngModel)]="state.description" class="form-control" rows="5"
							(input)="dataChanged()"></textarea>
					</div>
				</div>
			</div>
		</mat-card>
	</div>
</div>